module.exports = __webpack_public_path__ + "static/img/email_link_head.638cbec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email_link_head.png
// module id = bRCk
// module chunks = 16